
    var riot = require('riot')
    import { CollectionDropdownItem } from './gb-collection-dropdown-item';
riot.tag2('gb-collection-dropdown-item', '<a class="gb-collection" onclick="{selectDropdown}"> <span class="gb-collection__name">{$item.label || $item}</span> <gb-badge>{$collections.counts[$item.value || $item]}</gb-badge> </a>', 'gb-collection-dropdown-item.gb-stylish > a,[data-is="gb-collection-dropdown-item"].gb-stylish > a{ white-space: nowrap; }', '', function(opts) {
    this._mixin(CollectionDropdownItem);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/collections/gb-collection-dropdown-item.tag.html